/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react'
import { View, Image, Text, StyleSheet, Animated } from 'react-native'
import { initialGameInfo } from '../../App'
import { carbonbars } from '../../assets/carbonbar'
import { stackedbills } from '../../assets/stackedbill'

const GameInfo = (props) => {
  const fadeAnim = useRef(new Animated.Value(0)).current
  const [showInfoGraph, setShowInfoGraph] = useState(false)

  const fadeIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      useNativeDriver: false
    }).start()
  }

  useEffect(() => {
    if ((showInfoGraph === false && props.totalSavings > 0) || props.totalReductions > 0) {
      setShowInfoGraph(true)
      fadeIn()
    }
  })

  function getOpacity (max, current) {
    return Math.max(initialGameInfo.co2OpacityReductionMax, current / max)
  }

  const infobarnumber = initialGameInfo.co2ReductionsMax - props.totalReductions
  const cashinfonumber = props.totalSavings || 1

  return (
    <View style={styles.container}>
      <Image
        style={[styles.co2traffic, { opacity: getOpacity(initialGameInfo.co2Traffic, props.co2Traffic) }]}
        source={require('../../assets/symbols/co2_cloud.png')}
      />
      <Image
        style={[styles.co2spaces, { opacity: getOpacity(initialGameInfo.co2Public, props.co2Public) }]}
        source={require('../../assets/symbols/co2_cloud.png')}
      />
      <Image
        style={[styles.co2trash, { opacity: getOpacity(initialGameInfo.co2Wastes, props.co2Wastes) }]}
        source={require('../../assets/symbols/co2_cloud.png')}
      />
      <Image
        style={[styles.co2apartments, { opacity: getOpacity(initialGameInfo.co2Private, props.co2Private) }]}
        source={require('../../assets/symbols/co2_cloud.png')}
      />
      <Image
        style={[styles.co2energy, { opacity: getOpacity(initialGameInfo.co2Energy, props.co2Energy) }]}
        source={require('../../assets/symbols/co2_cloud.png')}
      />

      <Image style={styles.billtraffic} source={require('../../assets/symbols/bill4.png')} />
      <Image style={styles.billspaces} source={require('../../assets/symbols/bill7.png')} />
      <Image style={styles.billtrash} source={require('../../assets/symbols/bill2.png')} />
      <Image style={styles.billapartments} source={require('../../assets/symbols/bill6.png')} />
      <Image style={styles.billenergy} source={require('../../assets/symbols/bill3.png')} />

      <Text style={[styles.displayText, styles.trafficCo2]} id="traffic-co2">{props.co2Traffic}</Text>
      <Text style={[styles.displayText, styles.trafficCash]} id="traffic-cash">{props.cashTraffic}</Text>
      <Text style={[styles.displayText, styles.spacesCo2]} id="spaces-co2">{props.co2Public}</Text>
      <Text style={[styles.displayText, styles.spacesCash]} id="spaces-cash">{props.cashPublic}</Text>
      <Text style={[styles.displayText, styles.trashCo2]} id="trash-co2">{props.co2Wastes}</Text>
      <Text style={[styles.displayText, styles.trashCash]} id="trash-cash">{props.cashWastes}</Text>
      <Text style={[styles.displayText, styles.apartmentsCo2]} id="apartments-co2">{props.co2Private}</Text>
      <Text style={[styles.displayText, styles.apartmentsCash]} id="apartments-cash">{props.cashPrivate}</Text>
      <Text style={[styles.displayText, styles.energyCo2]} id="energy-co2">{props.co2Energy}</Text>
      <Text style={[styles.displayText, styles.energyCash]} id="energy-cash">{props.cashEnergy}</Text>

      <Text style={[styles.displayText, styles.cardsleft]} id="cards-left">{props.cardsLeft}</Text>

      { showInfoGraph &&
        <Animated.View style={[{ opacity: fadeAnim }]}>
          <Image style={styles.infograph} source={require('../../assets/symbols/infograph2.png')} />
          <Image style={styles.co2infobar}
            source={carbonbars[infobarnumber]}
          />
          <Image style={styles.totalbill}
            source={stackedbills[cashinfonumber]}
          />
          <Text style={[styles.displayText, styles.totalreductions]} id="totalreductions">{props.totalReductions}</Text>
          <Text style={[styles.displayText, styles.totalsavings]} id="totalsavings">{props.totalSavings}</Text>
        </Animated.View>
      }
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: 1200,
    height: 675,
    draggable: 'false',
    pointerEvents: 'none',
    userSelect: 'none'
  },
  displayText: {
    fontFamily: 'Arial Black, Gadget, sans-serif',
    fontSize: 22,
    fontStyle: 'italic',
    userSelect: 'none',
    draggable: 'false'
  },
  co2traffic: {
    position: 'absolute',
    left: 40,
    top: 10,
    width: 98,
    height: 54
  },
  co2spaces: {
    position: 'absolute',
    left: 42,
    top: 302,
    width: 98,
    height: 54
  },
  co2trash: {
    position: 'absolute',
    left: 428,
    top: 50,
    width: 98,
    height: 54
  },
  co2apartments: {
    position: 'absolute',
    left: 922,
    top: 9,
    width: 98,
    height: 54
  },
  co2energy: {
    position: 'absolute',
    left: 929,
    top: 396,
    width: 98,
    height: 54
  },
  billtraffic: {
    position: 'absolute',
    left: 275,
    top: 7,
    width: 86,
    height: 74
  },
  billspaces: {
    position: 'absolute',
    left: 219,
    top: 577,
    width: 86,
    height: 74
  },
  billtrash: {
    position: 'absolute',
    left: 682,
    top: 33,
    width: 86,
    height: 74
  },
  billapartments: {
    position: 'absolute',
    left: 1065,
    top: 317,
    width: 86,
    height: 74
  },
  billenergy: {
    position: 'absolute',
    left: 1086,
    top: 572,
    width: 86,
    height: 74
  },
  infograph: {
    position: 'absolute',
    left: 352,
    top: 556,
    width: 461,
    height: 109
  },
  totalbill: {
    position: 'absolute',
    left: 747,
    top: 562,
    width: 66,
    height: 102
  },
  cardsleft: {
    position: 'absolute',
    top: 290,
    left: 440,
    color: 'white',
    textAlign: 'left',
    width: 40
  },
  totalreductions: {
    position: 'absolute',
    top: 615,
    left: 530,
    color: 'white',
    textAlign: 'right',
    width: 40
  },
  co2infobar: {
    position: 'absolute',
    top: 562,
    left: 397,
    width: 21,
    height: 96
  },
  totalsavings: {
    position: 'absolute',
    top: 615,
    left: 625,
    color: 'white'
  },
  trafficCo2: {
    top: 70,
    left: 91,
    position: 'absolute'
  },
  trafficCash: {
    top: 67,
    left: 323,
    position: 'absolute'
  },
  spacesCo2: {
    top: 360,
    left: 92,
    position: 'absolute'
  },
  spacesCash: {
    top: 597,
    left: 192,
    position: 'absolute'
  },
  trashCo2: {
    top: 108,
    left: 485,
    position: 'absolute'
  },
  trashCash: {
    top: 108,
    left: 684,
    position: 'absolute'
  },
  apartmentsCo2: {
    top: 70,
    left: 977,
    position: 'absolute'
  },
  apartmentsCash: {
    top: 304,
    left: 1077,
    position: 'absolute'
  },
  energyCo2: {
    top: 457,
    left: 984,
    position: 'absolute'
  },
  energyCash: {
    top: 568,
    left: 1071,
    position: 'absolute'
  }
})

export default GameInfo
